export default __webpack_public_path__ + "static/media/pic73.41a062ef.jpg";